import React, { useLayoutEffect, useRef, useState } from 'react'

import { LabelStyle } from './style'

const PADDING_X = 16
const GAP = 24
const SPEED_PX_PER_SEC = 20
const MIN_DURATION_SEC = 10

export const FloorPlanLabel = ({ name, maxWidth, scale = 1, style }) => {
  const textRef = useRef(null)
  const [shift, setShift] = useState(0)

  useLayoutEffect(() => {
    const textWidth = textRef.current ? textRef.current.scrollWidth : 0
    setShift(textWidth > maxWidth - PADDING_X ? textWidth + GAP : 0)
  }, [name, maxWidth])

  const trackStyle = shift > 0
    ? { '--marquee-shift': `-${shift}px`, '--marquee-duration': `${Math.max(MIN_DURATION_SEC, shift / SPEED_PX_PER_SEC)}s` }
    : undefined

  return (
    <LabelStyle style={{ maxWidth, transform: `scale(${1 / scale}) translateX(-50%)`, ...style }}>
      <div className={`floor-plan-label-track${shift > 0 ? ' scrolling' : ''}`} style={trackStyle}>
        <span ref={textRef}>{name}</span>
        {shift > 0 && <span aria-hidden='true' style={{ paddingLeft: GAP }}>{name}</span>}
      </div>
    </LabelStyle>
  )
}

export default FloorPlanLabel
